export default __webpack_public_path__ + "static/gibkaya-cherepica-f1448a1c34b3c6434c4b1720801c9019.jpg";